// import {
//   HttpPost
// } from "../lib/login.request"
import {
  HttpPost3,
  HttpPost2,
  HttpPost
} from "../lib/api.request"
import {
  randomWord,
  getTimeStamp,
  tempLoginSign,
  loginSign
} from "../lib/sign"
import baseConfig from '../../../public/config.json'

export const reqLogin = (payload) => {
  //console.log(payload)
  //export const reqLogin = function (userId, password) {
  var randomStr
  var timestamp
  var sign
  randomStr = randomWord(true, 6, 8)
  timestamp = getTimeStamp()
  sign = loginSign(payload.userid, timestamp, randomStr, payload.passwd)
  //console.log(payload.userid,payload.tempid,payload.passwd)
  var bodyJson = {
    userid: payload.userid,
    tempuserguid:payload.tempid,
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign
  }
  console.log(bodyJson)
  return new Promise((resolve, reject) => {
    HttpPost2('/api/public/login/user', bodyJson)
      .then(function (resp) {
        console.log(resp)
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}

export const reqSMSLogin = (payload) => {
  var bodyJson={
    mobilenum:payload.mobilenum,
    tempuserguid:payload.tempid,
    smscode:payload.smscode
  }
  console.log(bodyJson)
  return new Promise((resolve, reject) => {
    HttpPost2('/api/public/login/mobile', bodyJson)
      .then(function (resp) {
        //console.log(resp)
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}



//无权限临时登录
export const reqTempLogin = () => {
  //export const reqTempLogin = function () {
  var randomStr
  var timestamp
  var sign
  var password
  //randomStr = randomWord(true, 6, 8)
  randomStr = randomWord(true, 10, 16)
  timestamp = getTimeStamp()
  password = baseConfig.tempLoginPwd
  sign = tempLoginSign(timestamp, randomStr, password)
  var bodyJson = {
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign
  }
  return new Promise((resolve, reject) => {
    HttpPost2('/api/public/login/tempuser', bodyJson)
      .then(function (resp) {
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}

//有权限的临时用户
export const reqTempUserLogin = () => {
  //export const reqTempLogin = function () {
  var randomStr
  var timestamp
  var sign
  var password
  //randomStr = randomWord(true, 6, 8)
  randomStr = randomWord(true, 10, 16)
  timestamp = getTimeStamp()
  password = baseConfig.tempLoginPwd
  sign = tempLoginSign(timestamp, randomStr, password)
  var bodyJson = {
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign
  }
  return new Promise((resolve, reject) => {
    HttpPost2('/api/public/login/matchuser', bodyJson)
      .then(function (resp) {
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}

export const reqTempVideo = () => {
  //export const reqTempLogin = function () {
  var randomStr
  var timestamp
  var sign
  var password
  //randomStr = randomWord(true, 6, 8)
  randomStr = randomWord(true, 10, 16)
  timestamp = getTimeStamp()
  password = baseConfig.tempLoginPwd
  sign = tempLoginSign(timestamp, randomStr, password)
  var bodyJson = {
    randstr: randomStr,
    timestamp: timestamp,
    sign: sign
  }
  return new Promise((resolve, reject) => {
    HttpPost2('/api/public/wxgzh/getvideoinfo', bodyJson)
      .then(function (resp) {
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}

export const refreshToken = () => {
  var bodyJson = {
  }
  console.log(bodyJson)
  return new Promise((resolve, reject) => {
    HttpPost('/api/public/security/user/refreshtoken',bodyJson)
      .then(function (resp) {
        console.log(resp)
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}

export const regTokenLogin = (payload) => {
  var bodyJson = {
    xtoken:payload.xtoken,
  }
  console.log(bodyJson)
  console.log("regTokenLogin===>")
  return new Promise((resolve, reject) => {
    HttpPost3('/api/public/login/tokenlogin',bodyJson)
      .then(function (resp) {
        console.log(resp)
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}

//登录激活团购账号
export const reqLoginActive = (payload) => {
  var bodyJson = {
    userid: payload.userid,
    mobilenum:payload.mobilenum,
    smscode: payload.smscode,
  }
  console.log(bodyJson)
  return new Promise((resolve, reject) => {
    HttpPost('/api/public/security/user/active', bodyJson)
      .then(function (resp) {
        console.log(resp)
        resolve(resp);
      }).catch(function (err) {
        reject(err);
      })
  })
}




// export  {
//   reqLogin,
//   reqTempLogin
// }
